export const SPECIAUX_ELIGIBILITE = [
    { id: 0, description: 'Tous' },
    { id: 1, description: 'Membres' },
    { id: 2, description: 'Non-Membres' },
]
export const SPECIAUX_TYPE = [
    { id: 0, description: 'Aucun' },
    { id: 1, description: 'Gratuité' },
    { id: 2, description: 'Livret' },
]